const apiToUsed =
  window.location.origin === process.env.REACT_APP_HOSTNAME
    ? process.env.REACT_APP_API_ENDPOINT
    : process.env.REACT_APP_API_STG_ENDPOINT

export default apiToUsed
